// Etykiety parametrów zadania wspólne dla listy i szczegółów.
import { formatDuration } from './podcastJob';

const LANGUAGE_LABELS = { pl: 'Polski', en: 'English', de: 'Deutsch', es: 'Español', cs: 'Čeština' };

export const languageLabel = (code) => (code ? LANGUAGE_LABELS[code] || code.toUpperCase() : null);

// Starsze zadania panelu mają `style` zamiast `tone`.
export const toneLabel = (job, t) => {
  if (job?.tone) return t(`podcasts.tones.${job.tone}`, { defaultValue: job.tone });
  if (job?.style) return job.style.charAt(0).toUpperCase() + job.style.slice(1);
  return null;
};

// Długość: gotowe nagranie (durationSeconds) albo docelowa (seconds).
export const lengthLabel = (job, t) => {
  const actual = formatDuration(job?.durationSeconds);
  if (actual) return actual;
  const target = formatDuration(job?.seconds);
  return target ? t('podcasts.list.targetLength', { value: target }) : null;
};
